import { Navigation } from "extensions/one-siam/components/domains/navigation/Navigation.kiosk-v"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const { sideMenus, matchedPath } = useAppUI()
  return <Navigation value={matchedPath?.to} navigations={sideMenus} />
}
